import(/* webpackMode: "eager" */ "/vercel/path0/app/empfehlungsprogramm/page.tsx");
